import {ref} from 'vue';
import {defineStore} from 'pinia';
import type {PurchaseOrderMonitoringSearchResultResource} from '@api';
import {Configuration, PurchaseOrderApi} from '@api';

const api = new PurchaseOrderApi(new Configuration({basePath: ''}));

export const usePurchaseOrderMonitoringStore = defineStore('purchase-order-monitoring', () => {
    const searchResult = ref<PurchaseOrderMonitoringSearchResultResource | undefined>(undefined);
    const loading = ref(false);
    const error = ref<unknown>(null);

    async function fetchPurchaseOrders(page = 0, size = 50) {
        loading.value = true;
        error.value = null;
        try {
            searchResult.value = await api.searchPurchaseOrders({page, size});
        } catch (e) {
            error.value = e;
            throw e;
        } finally {
            loading.value = false;
        }
    }

    return {
        searchResult,
        loading,
        error,
        fetchPurchaseOrders,
    };
});
